module.exports = __webpack_public_path__ + "img/video_bg1.dcb0ac49.jpg";